import { AdminContactStatesService, AdminContactsService } from '@/services';
import type { BulkTransitionResponse } from '@/services';
import type { AdminTransitionRuleResponse as AdminTransitionRule } from '@/services';
import type { ContactStateMachineResponse as ContactStateMachine } from '@/services';

export type { ContactStateMachine, BulkTransitionResponse };
export type { ContactStateInfo, ContactTransitionResult } from '@/services';

export const getContactStateMachine = (
  campaignId?: string | null
): Promise<ContactStateMachine> => {
  return AdminContactStatesService.getContactStateMachineApiAdminContactStatesMachineGet(
    campaignId
  ) as Promise<ContactStateMachine>;
};

export const bulkTransitionContacts = (
  contactIds: string[],
  targetState: string,
  reason?: string | null
): Promise<BulkTransitionResponse> => {
  return AdminContactsService.bulkTransitionContactsApiAdminContactsBulkTransitionPost(
    {
      contact_ids: contactIds,
      target_state: targetState,
      reason: reason || null,
    }
  );
};

/**
 * Client-side mirror of the backend guard, used only to annotate dropdown
 * options ("3/5 eligible") — the backend re-validates every contact.
 */
export const isTransitionAllowed = (
  rule: AdminTransitionRule,
  currentState: string | null | undefined,
  hasPhone: boolean,
  sensitiveSourceStates: string[],
  hasReason: boolean
): boolean => {
  const current = currentState || null;
  if (current === rule.target) return false;
  if (
    rule.allowed_from != null &&
    !rule.allowed_from.includes(current as string)
  )
    return false;
  if (rule.requires_phone && !hasPhone) return false;
  if (current && sensitiveSourceStates.includes(current) && !hasReason)
    return false;
  return true;
};
